module.exports = __webpack_public_path__ + "static/media/wizualizacja-25.b92ce323.png";